import React, { createContext, useContext } from 'react';
import { useGetAuthStatusQuery, useLogoutMutation, loginWithDiscord } from '../store/api/authApi';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  // Use RTK Query to automatically fetch and cache auth status
  const { data: authStatus, isLoading, refetch } = useGetAuthStatusQuery();
  const [logoutMutation] = useLogoutMutation();

  // Backend returns capitalized property names (C# convention)
  const isAuthenticated = authStatus?.isAuthenticated ?? authStatus?.IsAuthenticated ?? false;
  const user = authStatus?.user ?? authStatus?.User ?? null;

  const login = () => {
    loginWithDiscord();
  };

  const logout = async () => {
    try {
      await logoutMutation().unwrap();
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  const checkAuthStatus = () => {
    refetch();
  };

  return (
    <AuthContext.Provider value={{ 
      isAuthenticated, 
      user, 
      loading: isLoading, 
      login, 
      logout, 
      checkAuthStatus 
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

